import React from "react";
import Input from "../../../components/FormComponents/Input";
import Button from "../../../components/FormComponents/Button";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import BuilderTabs from "../../../Layouts/BuilderTabs";
import CodeEditor from "../../../components/BuilderComponents/CodeEditor/CodeEditor";
import Textarea from "../../../components/FormComponents/Textarea";

const EditGatewayOption = ({
  selectedItemData,
  setSelectedItemData,
  handleDelete,
  onClickFunctionUpdateSM,
  selectedItemDataExtraData,
  setSelectedItemDataExtraData,
  statesObject,
  removeTransitionFromGateway,
  procode = []
}) => {
  const addStateChangeLogic = () => {
    let rememberObj = { ...selectedItemData };
    if (rememberObj.state_change_logic) {
      rememberObj.state_change_logic.push({ state_id: "", condition: "true" });
    } else {
      rememberObj.state_change_logic = [{ state_id: "", condition: "true" }];
    }
    setSelectedItemData(rememberObj);
  };

  const addProcodeLogic = () => {
    let rememberObj = { ...selectedItemData };

    if (!rememberObj.procode_logic) {
      rememberObj.procode_logic = {
        procode_id: "",
        state_label_mapping: []
      };
    }

    if (!Array.isArray(rememberObj.procode_logic.state_label_mapping)) {
      rememberObj.procode_logic.state_label_mapping = [];
    }

    rememberObj.procode_logic.state_label_mapping.push({ state_id: "", label: "" });
    setSelectedItemData(rememberObj);
  };

  const changeLogic = (key, value, index) => {
    const rememberObj = { ...selectedItemData };
    if (key === "state_id") {
      if (!rememberObj.allow_state_targets) {
        rememberObj.allow_state_targets = [];
      }
      if (!rememberObj.allow_state_targets.includes(value)) {
        rememberObj.allow_state_targets.push(value);
      }
    }
    rememberObj.state_change_logic[index][key] = value;
    setSelectedItemData(rememberObj);
  };

  const changeProcodeLogic = (key, value, index) => {
    const rememberObj = { ...selectedItemData };
    if (!rememberObj.procode_logic) {
      rememberObj.procode_logic = {
        procode_id: "",
        state_label_mapping: []
      };
    }

    if (key === "procode_id") {
      rememberObj.procode_logic.procode_id = value;
    } else {
      rememberObj.procode_logic.state_label_mapping[index][key] = value;
    }
    setSelectedItemData(rememberObj);
  };

  const handleLogicTypeChange = (value) => {
    const rememberObj = { ...selectedItemData };
    rememberObj.logic_type = value;

    // Initialize procode_logic if procode is selected
    if (value === "procode" && !rememberObj.procode_logic) {
      rememberObj.procode_logic = {
        procode_id: "",
        state_label_mapping: []
      };
    }

    setSelectedItemData(rememberObj);
  };

  const getFilteredOptions = (currentIndex) => {
    const selectedStateIds =
      selectedItemData?.state_change_logic
        ?.map((logic, index) => (index !== currentIndex ? logic.state_id : null))
        .filter(Boolean) || [];

    return Object.values(statesObject).filter((state) => !selectedStateIds.includes(state.id));
  };

  const getProcodeFilteredOptions = (currentIndex) => {
    const selectedStateIds =
      selectedItemData?.procode_logic?.state_label_mapping
        ?.map((mapping, index) => (index !== currentIndex ? mapping.state_id : null))
        .filter(Boolean) || [];

    return Object.values(statesObject).filter((state) => !selectedStateIds.includes(state.id));
  };

  const deleteStateChangeLogic = (index, stateId) => {
    let rememberObj = { ...selectedItemData };
    rememberObj.state_change_logic.splice(index, 1);
    setSelectedItemData(rememberObj);
    removeTransitionFromGateway(stateId);
  };

  const deleteProcodeMapping = (index, stateId) => {
    let rememberObj = { ...selectedItemData };
    rememberObj.procode_logic.state_label_mapping.splice(index, 1);
    setSelectedItemData(rememberObj);
    removeTransitionFromGateway(stateId);
  };

  const logicTypeOptions = [
    { id: "", name: "State Base Logic" },
    { id: "procode", name: "Procode" }
  ];

  const switchToStateMachineTab = () => {
    const tabButtons = document.querySelectorAll(".sidebar_tabs");
    const stateMachineTab = Array.from(tabButtons).find((button) => button.textContent.trim() === "State Base Logic");
    if (stateMachineTab) {
      stateMachineTab.click();
    }
  };

  function getProcodeName(procodeId) {
    return procode.find((procode) => procode.id === procodeId)?.name;
  }

  const summaryContent = (
    <div className="rightPanel_inside_container g_12">
      <div className="builder_form">
        <Input
          label="Gateway Name"
          value={selectedItemData.name}
          onChange={(e) => setSelectedItemData({ ...selectedItemData, name: e.target.value })}
        />
      </div>
      <div className="builder_form g_4" style={{ marginTop: "8px", marginBottom: "20px" }}>
        <p className="builder_label">Gateway Box Size</p>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ButtonActionIcon
            type="remove"
            onClick={() =>
              setSelectedItemDataExtraData({
                ...selectedItemDataExtraData,
                w: selectedItemDataExtraData.w - 20,
                h: selectedItemDataExtraData.h - 20
              })
            }
          />
          <span>{selectedItemDataExtraData.w}px</span>
          <ButtonActionIcon
            type="add"
            onClick={() =>
              setSelectedItemDataExtraData({
                ...selectedItemDataExtraData,
                w: selectedItemDataExtraData.w + 20,
                h: selectedItemDataExtraData.h + 20
              })
            }
          />
        </div>
      </div>

      {selectedItemData.logic_type === "procode" ? (
        <div>
          <div className="inline_tag_items">
            <div className="section_main_heading">Procode Mapping</div>
          </div>
          <div className="summary_card">
            <div className="form_edit_del_buttons">
              <button
                className="builder_action_btn  edit"
                title=""
                style={{ width: "32px", height: "32px", fontsize: "20px" }}
                onClick={switchToStateMachineTab}
              >
                <MaterialIcon name="edit" style={{ fontSize: "20px" }} />
              </button>
            </div>
            <div className="overlay_cover"></div>
            <div className="state_changeLogic_summary_container">
              <div className="builder_label mb_2">
                Procode:
                <span className="key_tag">{getProcodeName(selectedItemData.procode_logic?.procode_id) || "None"}</span>
              </div>
              {selectedItemData?.procode_logic?.state_label_mapping?.length > 0 ? (
                selectedItemData.procode_logic.state_label_mapping.map((mapping, index) => (
                  <div key={index} className="stateMachine_form_container_item">
                    <div className="builder_label">
                      State Name:{" "}
                      <span className="key_tag">
                        {mapping.state_id ? statesObject[mapping.state_id]?.name : "None"}
                      </span>
                    </div>
                    <div className="builder_label">
                      Label: <span className="key_tag">{mapping.label}</span>
                    </div>
                  </div>
                ))
              ) : (
                <div className="key_tag flex_row justify_center align_center">
                  <p>No state mappings</p>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="inline_tag_items">
            <div className="section_main_heading">State Base Logic</div>
          </div>
          <div className="summary_card">
            <div className="form_edit_del_buttons">
              <button
                className="builder_action_btn  edit"
                title=""
                style={{ width: "32px", height: "32px", fontsize: "20px" }}
                onClick={switchToStateMachineTab}
              >
                <MaterialIcon name="edit" style={{ fontSize: "20px" }} />
              </button>
            </div>
            <div className="overlay_cover"></div>
            <div className="state_changeLogic_summary_container">
              {selectedItemData?.state_change_logic?.length > 0 ? (
                selectedItemData.state_change_logic.map((logic, index) => (
                  <div key={index} className="stateMachine_form_container_item">
                    <div className="builder_label">
                      State Name:{" "}
                      <span className="key_tag">{logic.state_id ? statesObject[logic.state_id]?.name : "None"}</span>
                    </div>
                    <div className="builder_label">
                      Condition: <span className="key_tag">{logic.condition}</span>
                    </div>
                  </div>
                ))
              ) : (
                <div className="key_tag">
                  <p>None</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );

  const stateMachineContent = (
    <div>
      <div className="builder_form">
        <SingleSelectBox
          label="Logic Type"
          selectedData={selectedItemData.logic_type || ""}
          options={logicTypeOptions}
          onChange={(obj) => handleLogicTypeChange(obj.id)}
          placeholder="Select Logic Type"
        />
      </div>

      {selectedItemData.logic_type === "procode" ? (
        <div>
          <div className="builder_form mt_3" style={{ marginBottom: "20px" }}>
            <SingleSelectBox
              label="Procode"
              selectedData={selectedItemData.procode_logic?.procode_id || ""}
              options={procode.map((procode) => ({ id: procode.id, name: procode.name }))}
              onChange={(obj) => changeProcodeLogic("procode_id", obj.id)}
              placeholder="Select Procode"
            />
          </div>

          <div className="inline_tag_items">
            <div className="section_main_heading">Procode Mapping</div>
            <MaterialIcon name="add" className="builder_action_btn" onClick={addProcodeLogic} />
          </div>

          <div className="state_changeLogic_inputs_container">
            {selectedItemData?.procode_logic?.state_label_mapping?.map((mapping, index) => (
              <ProcodeStateMappingItem
                key={index}
                index={index}
                mapping={mapping}
                changeProcodeLogic={changeProcodeLogic}
                statesObject={statesObject}
                deleteProcodeMapping={deleteProcodeMapping}
                filteredOptions={getProcodeFilteredOptions(index)}
              />
            ))}
          </div>
        </div>
      ) : (
        <div>
          <div className="inline_tag_items mt_2">
            <div className="section_main_heading">State Base Logic</div>
            <MaterialIcon name="add" className="builder_action_btn" onClick={addStateChangeLogic} />
          </div>
          <div className="state_changeLogic_inputs_container">
            {selectedItemData?.state_change_logic?.map((logic, index) => (
              <StateChangeLogicItem
                key={index}
                index={index}
                logic={logic}
                changeLogic={changeLogic}
                statesObject={statesObject}
                deleteStateChangeLogic={deleteStateChangeLogic}
                filteredOptions={getFilteredOptions(index)}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );

  const tabs = [
    {
      label: "Summary",
      content: summaryContent
    },
    {
      label: "State Base Logic",
      content: stateMachineContent
    }
  ];

  return (
    <div>
      <div className="sm_blueprint_editBox edit_screen_fields" style={{ padding: "0px", width: "500px" }}>
        <BuilderTabs tabs={tabs} contentStyle={{ padding: "20px" }} />
      </div>

      <div className="save_block down" style={{ padding: "0px 20px" }}>
        <Button variant="delete" onClick={handleDelete}>
          Delete Gateway
        </Button>
        <Button onClick={onClickFunctionUpdateSM}>Apply</Button>
      </div>
    </div>
  );
};

export default EditGatewayOption;

const StateChangeLogicItem = ({ index, logic, changeLogic, deleteStateChangeLogic, filteredOptions }) => {
  return (
    <div className="summary_card" key={index}>
      <div className="builder_form g_4">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <label className="builder_label"> Select state</label>
          <MaterialIcon
            name="delete"
            className="builder_action_btn"
            style={{ marginLeft: "auto" }}
            onClick={() => deleteStateChangeLogic(index, logic.state_id)}
          />
        </div>
        <div className="flex_column gap_2">
          <SingleSelectBox
            selectedData={logic.state_id}
            options={filteredOptions}
            onChange={(obj) => changeLogic("state_id", obj.id, index)}
            placeholder="Select State"
          />
        </div>
        <div className="flex_column gap_2 mt_1">
          <label className="builder_label">Condition</label>
          <CodeEditor
            fieldObj={{}}
            value={logic.condition || ""}
            language="javascript"
            height="120px"
            tableID=""
            handleChange={(value) => changeLogic("condition", value, index)}
            enableBacktickTrigger={true}
          />
        </div>
        <div className="builder_form">
          <Textarea
            placeholder="describe the condition"
            label="description"
            value={logic.description}
            onChange={(e) => changeLogic("description", e.target.value, index)}
          />
        </div>
        <div className="builder_form">
          <Input label="label" value={logic.label} onChange={(e) => changeLogic("label", e.target.value, index)} />
        </div>
      </div>
    </div>
  );
};

const ProcodeStateMappingItem = ({ index, mapping, changeProcodeLogic, deleteProcodeMapping, filteredOptions }) => {
  return (
    <div className="summary_card" key={index}>
      <div className="builder_form g_4">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <label className="builder_label">Select State</label>
          <MaterialIcon
            name="delete"
            className="builder_action_btn"
            style={{ marginLeft: "auto" }}
            onClick={() => deleteProcodeMapping(index, mapping.state_id)}
          />
        </div>
        <SingleSelectBox
          selectedData={mapping.state_id}
          options={filteredOptions}
          onChange={(obj) => changeProcodeLogic("state_id", obj.id, index)}
          placeholder="Select State"
        />
      </div>
      <div className="builder_form mt_2">
        <Input
          label="Label"
          value={mapping.label}
          onChange={(e) => changeProcodeLogic("label", e.target.value, index)}
          placeholder="Enter label"
        />
      </div>
    </div>
  );
};
